angular.module('impactx.catalog').controller('CatalogArchiveListController', CatalogArchiveListController);

CatalogArchiveListController.$inject = ['$routeParams', 'selectedListItems', 'DownloadService'];

function CatalogArchiveListController($routeParams, selectedListItems, DownloadService)
{
    var self = this;
    this.downloadZip = function()
    {
        DownloadService.openDownloadPost('/catalog/archive/download', {paramName: "id", paramValue: selectedListItems.getFirstSelectedId()})
    };

    var buttonDefinition = [{
        label: "download",
        action: self.downloadZip,
        condition: selectedListItems.isSingleSelection,
        process: 'Catalog'
    }];

    this.meta = {
        rowTemplate: 'modules/catalog/templates/catalogarchivelist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/catalog/archivelist',
        ctrl: this,
        valuesInteger: [{name:"CatId", value: $routeParams.catId}],
        id: "catalogarchivelist",
        excelExport: true,
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}